import { validateEmail } from "@utils/validate-email";

// Constants
const DOMAINS_BLACKLIST = ["gmail.it"];

export const checkIfEmailDomainExists = async (email, apiRequest) => {
  if (!validateEmail(email)) return null;
  const domain = email.split("@").pop();
  if (DOMAINS_BLACKLIST.includes(domain)) return false;

  try {
    const result = await apiRequest.get("/dnscheck/", {
      publicRequest: true,
      params: { name: domain, type: "MX" },
    });
    return result?.Status === 0;
  } catch (error) {
    console.log("error", error);
    return false;
  }
};

export default checkIfEmailDomainExists;
